import { Box, Grid, Button, Typography, Divider } from "@mui/material";
import Link from "@mui/material/Link";
import { useEffect, useState } from "react";
import FormPersonalInfo from "./FormPersonalInfo";
import ServiceInfo from "./ServiceinFo";
import PersonSign from "./PersonSign";
import AttachEvidence from "./AttachEvidence";
import Swal from "sweetalert2";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useHistory, useLocation } from "react-router-dom"; // version 5.2.0
import FormPersonalInfoV1 from "./FormPersonalInfoV1";
import ServiceinFoV1 from "./ServiceinFoV1";
import PersonSignV1 from "./PersonSignV1";
import AttachEvidenceV1 from "./AttachEvidenceV1";
import axios from "axios";
import { APIEndpointWeb, GetLocalStorageAccessToken, GetLocalStorageOrganization, webapi } from "../../../../client/web";
import dayjs from "dayjs";
import cloneDeep from "lodash/cloneDeep";
import { isEmpty } from "lodash";
import { IResultDetail } from "../DocumentPersonalComponent/DetailDocPersonal";
import LoadingIndicator from "../PersonalDataAgreementComponent/Loading/LoadingIndicator";
import ConfirmAndSuccessDialog from "./ConfirmAndSuccessDialog";


export interface Ico_professional {
    // length: number;
    // prefix: string;
    // firstname_th: string;
    // lastname_th: string;
    // full_cid: string;
    // license_id: string;
    // position: string;
    // department: string;
    // organization: string;
    // mobile_number: string;
    // email: string;
    prefix: string;
    firstname_th: string;
    lastname_th: string;
    full_cid: string;
    license_code: string;
    address: string;
    moo: string;
    soi: string;
    street: string;
    sub_district: string;
    district: string;
    province: string;
    zip_code: string;
    email: string;
    mobile_number: string;
}

export interface FormData {
    write_at: string | dayjs.Dayjs | null;
    write_date: string;
    firstname_th: string;
    lastname_th: string;
    age: string;
    nationality: string;
    full_cid: string;
    license_code: string;
    business_name_th: string;
    business_firstname_th_1: string;
    business_lastname_th_1: string;
    business_full_cid_1: string;
    business_firstname_th_2: string;
    business_lastname_th_2: string;
    business_full_cid_2: string;
    business_type: string;
    business_create_date: string;
    business_code: string;
    current_address: {
        address: string;
        moo: string;
        soi: string;
        street: string;
        sub_district: string;
        district: string;
        province: string;
        zip_code: string;
        email: string;
        mobile_number: string;
    };
    organization_data: {
        health_office_type: string;
        hname_th: string;
        hcode: string;
        address: string;
        moo: string;
        soi: string;
        street: string;
        sub_district: string;
        district: string;
        province: string;
        zip_code: string;
        email: string;
        mobile_number: string;
    };
    service_type: string;
    service_type_note: string;
    co_professional: Ico_professional[];
 

}

export interface IProvince {
    province_thai_name: string;
    province_english_name: string;
    province_code: string;
}


export interface IDistrict {
    district_code: string;
    district_english_name: string;
    district_thai_name: string;
    province_code: string
}

export interface ITambon {
    country_code: string;
    district_code: string;
    province_code: string;
    region_code: string;
    tambon_code: string;
    tambon_english_name: string;
    tambon_thai_name: string;
    zip_code: string;
}

interface LocationState {
    resultDetail: any;
  }


const MainFormPersonaNewV1: React.FC = (): JSX.Element => {
    const [activeStep, setActiveStep] = useState(0);
    const steps = ["Step 1", "Step 2", "Step 3", "Step 4"];
    const [consentAgreement, setConsentAgreement] = useState(false);

    // State สำหรับเก็บข้อมูลจากฟอร์ม
    const [formData, setFormData] = useState<FormData>({
        write_at: "",
        write_date: "",
        firstname_th: "",
        lastname_th: "",
        age: "",
        nationality: "",
        full_cid: "",
        license_code: "",
        business_name_th: "",
        business_firstname_th_1: "",
        business_lastname_th_1: "",
        business_full_cid_1: "",
        business_firstname_th_2: "",
        business_lastname_th_2: "",
        business_full_cid_2: "",
        business_type: "",
        business_create_date: "",
        business_code: "",
        current_address: {
            address: "",
            moo: "",
            soi: "",
            street: "",
            sub_district: "",
            district: "",
            province: "",
            zip_code: "",
            email: "",
            mobile_number: "",
        },
        organization_data: {
            health_office_type: "",
            hname_th: "",
            hcode: "",
            address: "",
            moo: "",
            soi: "",
            street: "",
            sub_district: "",
            district: "",
            province: "",
            zip_code: "",
            email: "",
            mobile_number: "",
        },
        service_type: "",
        service_type_note: "",
        co_professional: [{
            prefix: "",
            firstname_th: "",
            lastname_th: "",
            full_cid: "",
            license_code: "",
            address: "",
            moo: "",
            soi: "",
            street: "",
            sub_district: "",
            district: "",
            province: "",
            zip_code: "",
            email: "",
            mobile_number: "",
        }],
       
    });

    const [formDataForOnePage] = useState<string[]>(["write_at", "write_date", "firstname_th", 
        "lastname_th", "age", "nationality", "full_cid", "license_code", "business_name_th", 
        "business_firstname_th_1", "business_lastname_th_1", "business_full_cid_1",
        "business_type", "business_create_date", "business_code","service_type", "service_type_note"
    ]);


    const [formDataForOrganizationData] = useState<string[]>(["health_office_type", "hname_th", "hcode", 
        "address", "moo", "soi", "street", "sub_district", "district", 
        "province", "zip_code", "email", "mobile_number",
    ]);


    const [formDataForCurrentAddress] = useState<string[]>(["address", "moo", "soi", 
        "street", "sub_district", "district", "province", "zip_code", "email", "mobile_number"
    ]);


    const [formDataForCoProfessional] = useState<string[]>(["prefix", "firstname_th", "lastname_th", 
        "full_cid", "license_code", "address", "moo", "soi", "street", "sub_district","district", "province", "zip_code", "email", "mobile_number"
    ]);
    const [checkPage234, setCheckPage234] = useState<string | null>("");


 

    const [allProvince, setAllProvince] = useState<IProvince[]>([]);
    const [errors, setErrors] = useState<any>({});
    const history = useHistory();
    const [localStorageOrganization, setLocalStorageOrganization] = useState<any>(null);
    const [accessToken, setAccessToken] = useState<string>(
        GetLocalStorageAccessToken()
    );
    const location = useLocation<LocationState>();
    const dataPageForm = location.state || {};
    const [resultDetail, setResultDetail] = useState<IResultDetail>({} as IResultDetail);
  const [loading, setLoading] = useState<boolean>(false);
      const [openConfirmDialog, setOpenConfirmDialog] = useState(false); // 🔹 Dialog 3: ยืนยันการเซ็น
    const [openSuccessDialog, setOpenSuccessDialog] = useState(false); // 🔹 Dialog 4: เซ็นสำเร็จ
    const [formDatamockPriority3, setFormDatamockPriority3] = useState<any>(null);
    useEffect(() => {
        let glso = GetLocalStorageOrganization();
        setLocalStorageOrganization(glso); 
        try {
            let params = new URLSearchParams(document.location.search);
            let page = params.get("page");
            setCheckPage234(page)
            // console.log("dataPageForm", dataPageForm.resultDetail)
            if ((dataPageForm.resultDetail && Object.keys(dataPageForm.resultDetail).length > 0 && dataPageForm.resultDetail.constructor === Object) && page === "3") {
                handleSubmitDocumentPreview(glso, dataPageForm.resultDetail);
                setResultDetail(dataPageForm.resultDetail)
            } else {
                handleSubmitDocumentPreview(glso);
                setCheckPage234("")
            }
        } catch (error) {
            handleSubmitDocumentPreview(glso);
        }
    
        // console.log(page)
    }, []);


    useEffect(() => {
        // console.log("errors", errors)
    }, [errors]);


    // useEffect(() => {
    //     // if (localStorageOrganization) {
    //     //     handleSubmitDocumentPreview();
    //     // }
    // }, [localStorageOrganization]);


    // console.log('formData :>> ', formData);
    // ฟังก์ชันตรวจสอบข้อมูล
    // const validateForm = () => {
    //     let newErrors: { [key: string]: boolean } = {};

    //     // Object.entries(formData).forEach(([key, value]) => {
    //     //   if (!value) newErrors[key] = true;
    //     // });

    //     // ตรวจสอบ formDataLegalEntity โดยไม่เช็คค่า firstName2, lastName2, citizenId2
    //     Object.entries(formData).forEach(([key, value]) => {
    //         // ตรวจสอบค่าเฉพาะฟิลด์ที่ไม่ใช่ firstName2, lastName2, citizenId2
    //         if (!value && !["business_firstname_th_2", "business_lastname_th_2", "business_full_cid_2"].includes(key)) {
    //             newErrors[key] = true;
    //         }
    //     });

    //     // ตรวจสอบ current_address
    //     Object.entries(formData.current_address).forEach(([key, value]) => {
    //         if (!value) {
    //             newErrors[`current_address.${key}`] = true;
    //         }
    //     });
    //     setErrors(newErrors);
    //     return Object.keys(newErrors).length === 0;
    // };
    const validateEmail = (email: string) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
};

const isValidThaiIdCard = (id: string): boolean => {
    if (!/^[1-9]\d{12}$/.test(id)) return false;
  
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseInt(id.charAt(i)) * (13 - i);
    }
    const checkDigit = (11 - (sum % 11)) % 10;
  
    return checkDigit === parseInt(id.charAt(12));
  };
  function allowOnlyNumbers(value: string): string {
    return value.replace(/[^0-9]/g, "");
  }
  
  function isValidAge(value: string): boolean {
    const number = parseInt(value, 10);
    return !isNaN(number) && number >= 20;
  }

  const validateLicenseCode = (value: string): boolean => {
    const regex = /^[ก-ฮa-zA-Z0-9]{5,10}$/;
    return regex.test(value); // Returns true if valid, false otherwise
  };
const validateMobile = (business_full_cid_1: string) => {
    return /^[0-9]{10}$/.test(business_full_cid_1);
  };

    const validateForm = () => {
        
        let newErrors: any = {};

        // ตรวจสอบ formData โดยไม่เช็ค firstName2, lastName2, citizenId2, document_id, document_no
        Object.entries(formData).forEach(([key, value]) => {
            // ข้ามการตรวจสอบ document_id, document_no
            // console.log("key", key, "-",value)
           
            if ((value === "" || value === null || value === undefined) && formDataForOnePage.includes(key)) {
 // !["business_firstname_th_2", "business_lastname_th_2", "business_full_cid_2", "document_id", "document_no"].includes(key) !["document_id", "document_no"].includes(key)
                if (activeStep === 0 && ["service_type", "service_type_note"].includes(key)) {
                    // newErrors[key] = true;
                } else if (activeStep >= 1 &&  !(["สหคลินิก", "อื่นๆ"].includes(formData.service_type)) && key === "service_type_note") { /////////////////////// ดักหน้า 2
                    // newErrors[key] = true;
                } else if (activeStep >= 1 &&    ["สหคลินิก", "อื่นๆ"].includes(formData.service_type) && key === "service_type_note"){
                       newErrors[key] = true;
                
                } else {
                    newErrors[key] = true;
                }
            } 

            if (key === "full_cid"){
                if (value.length !== 13 || !isValidThaiIdCard(value)) {
                    newErrors[key] = true;
                  }
            } 
            if (key === "age") {
                const numericValue = allowOnlyNumbers(value);
                if (!isValidAge(numericValue)) {
                  newErrors[key] = true; // ใส่ error ถ้าอายุน้อยกว่า 20 หรือไม่ใช่ตัวเลข
                }
              }

              if (key === "license_code") {
                if (!validateLicenseCode(value)) {
                  newErrors[key] = true; // ใส่ error ถ้าอายุน้อยกว่า 20 หรือไม่ใช่ตัวเลข
                }
              }
          

            if (key === "business_full_cid_1") {
                if (value.length !== 13 || !isValidThaiIdCard(value)) {
                  newErrors[key] = true;
                }
              } 

              if (key === "business_full_cid_2" && value) {
                if (value.length !== 13 || !isValidThaiIdCard(value)) {
                  newErrors[key] = true;
                }
              }

              if (key === "business_code") {
                if (value.length !== 13 || !/^\d{13}$/.test(value)) {
                  newErrors[key] = true;
                }
              }

              if (key === "business_name_th") {
                if (value.length !== 13 || !/^\d{13}$/.test(value)) {
                  newErrors[key] = true;
                }
              }
              if (key === "zip_code") {
                if (!/^[0-9]{5}$/.test(value)) {
                  newErrors[key] = true;
                }
              }  

        });

        // ตรวจสอบ current_address
        if (formData.current_address && typeof formData.current_address === "object") {
            newErrors.current_address = {}
            Object.entries(formData.current_address).forEach(([key, value]) => {
                if (value === "" || value === null || value === undefined && activeStep === 0 && formDataForCurrentAddress.includes(key)) {
                    // console.log("steps", activeStep)
                    // console.log("current_address", key)
                    // newErrors[`current_address.${key}`] = true;
                    //   newErrorscurrent_address.${key}`][key] = true;
                    newErrors.current_address[key] = true;
                }

                if (key === "email" && !validateEmail(value)){
                    newErrors.current_address[key] = true
                } 
    
                if (key === "mobile_number" && !validateMobile(value)){
                    newErrors.current_address[key] = true
                } 
                if (key === "business_code") {
                    if (value.length !== 13 || !/^\d{13}$/.test(value)) {
                      newErrors[key] = true;
                    }
                  }
    
                  if (key === "business_name_th") {
                    if (value.length !== 13 || !/^\d{13}$/.test(value)) {
                      newErrors[key] = true;
                    }
                  }
                  if (key === "zip_code") {
                    if (!/^[0-9]{5}$/.test(value)) {
                      newErrors[key] = true;
                    }
                  }
            });
            if (Object.keys(newErrors.current_address).length === 0) {
               delete newErrors.current_address
            }
        }


        if (formData.organization_data && typeof formData.organization_data === "object" && activeStep === 1) {
            newErrors.organization_data = {}
            Object.entries(formData.organization_data).forEach(([key, value]) => {
                if (value === "" || value === null || value === undefined && formDataForOrganizationData.includes(key)) {
                    // console.log("steps", activeStep)
                    // console.log("organization_data", key)
                    // newErrors[`organization_data.${key}`] = true;
                    //   organization_data.${key}`][key] = true;
                    newErrors.organization_data[key] = true;
                }

                if (key === "email" && !validateEmail(value)){
                    newErrors.organization_data[key] = true
                } 
    
                if (key === "mobile_number" && !validateMobile(value)){
                    newErrors.organization_data[key] = true
                } 
            });
            if (Object.keys(newErrors.organization_data).length === 0) {
               delete newErrors.organization_data
            }
        }

 
        if (formData.co_professional && Array.isArray(formData.co_professional) && formData.co_professional.length > 0  && activeStep === 2) {
            newErrors.co_professional = []
            for (var index in formData.co_professional) {
                let keyOfCoProfessional: { [key: string]: boolean } = {}
                Object.entries(formData.co_professional[index]).forEach(([key, value]) => {
                    // console.log("first",key, value)
                        if (value === "" || value === null || value === undefined && formDataForCoProfessional.includes(key)) {
                            keyOfCoProfessional[key] = true
                        } 
                        if (key === "full_cid" && (value.length !== 13 || !isValidThaiIdCard(value))) {
                            keyOfCoProfessional[key] = true;
                        }
        
                        if (key === "email" && !validateEmail(value)){
                            keyOfCoProfessional[key] = true
                        } 
                        
                        if (key === "mobile_number" && !validateMobile(value)){
                            keyOfCoProfessional[key] = true
                        } 
                        if (key === "zip_code") {
                            if (!/^[0-9]{5}$/.test(value)) {
                              newErrors[key] = true;
                            }
                          }
                          if (key === "license_code") {
                            if (!validateLicenseCode(value)) {
                                keyOfCoProfessional[key] = true; // ใส่ error ถ้าอายุน้อยกว่า 20 หรือไม่ใช่ตัวเลข
                            }
                          }
    
                    });
                // if (Object.keys(keyOfCoProfessional).length > 0) {
                        newErrors.co_professional.push(keyOfCoProfessional)
                // }
            }


            
            var ddcmg :boolean = true
            for (var indexc in newErrors.co_professional) {
                   if (Object.keys(newErrors.co_professional[indexc]).length === 0) {
                    // console.log("x",Object.keys(newErrors.co_professional[indexc]).length)
                    // delete newErrors.co_professional[indexc]
                    // newErrors.co_professional.splice(indexc, 1)
                    } else {
                        ddcmg = false
                    }
              }
            if (ddcmg) {
                delete newErrors.co_professional
             }
           }
        // console.log(activeStep)
        // เพิ่มการตรวจสอบอำเภอ
        // if (!formData.current_address.district) {
        //     newErrors["current_address.district"] = true;
        // }
        // console.log(Object.keys(newErrors.current_addressx).length)
        setErrors(newErrors); // อัพเดต errors
        return Object.keys(newErrors).length === 0;  // ถ้าไม่มี error คืนค่า true
    };

    // const validateForm = () => {
    //     let newErrors: { [key: string]: boolean } = {};

    //     // Basic fields validation
    //     if (!formData.address) newErrors.address = true;
    //     if (!formData.write_at) newErrors.write_at = true;
    //     if (!formData.write_date) newErrors.write_date = true;
    //     if (!formData.firstname_th) newErrors.firstname_th = true;
    //     if (!formData.lastname_th) newErrors.lastname_th = true;
    //     if (!formData.age) newErrors.age = true;
    //     if (!formData.nationality) newErrors.nationality = true;
    //     if (!formData.full_cid) newErrors.full_cid = true;
    //     if (!formData.license_code) newErrors.license_code = true;
    //     if (!formData.business_name_th) newErrors.business_name_th = true;
    //     if (!formData.business_firstname_th_1) newErrors.business_firstname_th_1 = true;
    //     if (!formData.business_lastname_th_1) newErrors.business_lastname_th_1 = true;
    //     if (!formData.business_full_cid_1) newErrors.business_full_cid_1 = true;
    //     if (!formData.business_firstname_th_2) newErrors.business_firstname_th_2 = true;
    //     if (!formData.business_lastname_th_2) newErrors.business_lastname_th_2 = true;
    //     if (!formData.business_full_cid_2) newErrors.business_full_cid_2 = true;
    //     if (!formData.business_create_date) newErrors.business_create_date = true;
    //     if (!formData.business_type) newErrors.business_type = true;
    //     if (!formData.business_code) newErrors.business_code = true;

    //     // Validate current_address fields
    //     if (!formData.current_address) {
    //         newErrors["current_address"] = true;
    //         console.log('1 :>> ',);
    //     } else {
    //         console.log('2 :>> ',);
    //         // Check each field inside current_address
    //         if (!formData.current_address) newErrors["current_address"] = true;
    //         if (!formData.current_address.moo) newErrors["current_address.moo"] = true;
    //         if (!formData.current_address.soi) newErrors["current_address.soi"] = true;
    //         if (!formData.current_address.street) newErrors["current_address.street"] = true;
    //         if (!formData.current_address.sub_district) newErrors["current_address.sub_district"] = true;
    //         if (!formData.current_address.district) newErrors["current_address.district"] = true;
    //         if (!formData.current_address.province) newErrors["current_address.province"] = true;
    //         if (!formData.current_address.zip_code) newErrors["current_address.zip_code"] = true;
    //         if (!formData.current_address.email) newErrors["current_address.email"] = true;
    //         if (!formData.current_address.mobile_number) newErrors["current_address.mobile_number"] = true;
    //         if (!formData.current_address.sub_district) {
    //             newErrors["current_address.sub_district"] = true;
    //         }
    //     }
    //     console.log("formData.current_address: ", formData.current_address.address);
    //     console.log("Errors: ", newErrors);

    //     // Update errors state
    //     setErrors(newErrors);

    //     // Return false if there are errors, true if no errors
    //     return Object.keys(newErrors).length === 0;
    // };
    // const validateForm = () => {
    //     let newErrors: { [key: string]: boolean } = {};

    //     // Basic fields validation
    //     const basicFields = [
    //         'address', 'write_at', 'write_date', 'firstname_th', 'lastname_th',
    //         'age', 'nationality', 'full_cid', 'license_code', 'business_name_th',
    //         'business_firstname_th_1', 'business_lastname_th_1', 'business_full_cid_1',
    //         'business_firstname_th_2', 'business_lastname_th_2', 'business_full_cid_2',
    //         'business_create_date', 'business_type', 'business_code'
    //     ];
    //     basicFields.forEach((field) => {
    //         if (!(formData as any)[field]) newErrors[field] = true;
    //     });

    //     // Validate current_address fields
    //     if (!formData.current_address || typeof formData.current_address !== 'object') {
    //         newErrors["current_address"] = true;
    //     } else {
    //         const addressFields = [
    //             'address', 'moo', 'soi', 'street', 'sub_district', 'province', 'zip_code',
    //             'email', 'mobile_number', 'district'
    //         ];

    //         addressFields.forEach((field) => {
    //             if (!formData.current_address[field as keyof typeof formData.current_address]) newErrors[`current_address.${field}`] = true;
    //         });
    //     }
    // console.log('newErrors :>> ', newErrors);
    //     // Update errors state
    //     setErrors(newErrors);

    //     // Return false if there are errors, true if no errors
    //     return Object.keys(newErrors).length === 0;
    // };


    const handleNext = () => {
        if (!validateForm()) {
            Swal.fire({
                title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                icon: "info",
                confirmButtonText: "ตกลง",
            });
            return;
        }
        if (checkPage234 === "3" && activeStep === 2) {
            handleNewForm()
              return false
        }
        setActiveStep((prevStep) => Math.min(prevStep + 1, steps.length - 1));
    };

    const handleBack = () => {
        setActiveStep((prevStep) => Math.max(prevStep - 1, 0));
    };


    const handleSubmitDocumentPreview = async (localStorageOrganizationx : any , dataPageFormx: any = null) => {
        // const handleSubmitDocumentPreview = async (e: React.FormEvent) => {
        // e.preventDefault();
        // if (!validateForm()) {
        //     Swal.fire({
        //         title: "กรุณากรอกข้อมูลให้ครบถ้วน",
        //         icon: "info",
        //     });
        //     return;
        // }

        // console.log("formData :>> ", formData);

        try {
              setLoading(true)
            const dataFormApi = {
                hcode: localStorageOrganizationx ? localStorageOrganizationx.hcode : "",
                document_no: dataPageFormx?.document_no ? dataPageFormx.document_no : ""
            }

            var { data } = await webapi.post(`${APIEndpointWeb.PostDetailDocumentPreview}`, dataFormApi,
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );

            // console.log('data.result :>> ', data.result);
            // let datat = convertToISODate(data.result.write_date)
            // console.log('datat :>> ', datat);
            // console.log('datat :>>xxxxxxxxxx ', dayjs())
            // try {
            //     if (data?.result?.write_date) {
            //         let datat = convertToISODate(data.result.write_date)
            //         // console.log(data.result.write_date, "->", datat)
            //         data.result.write_date = dayjs(datat).add(-543, 'year');
            //     } else {
            //         data.result.write_date = dayjs()
            //     }
            // } catch (error) {
            //     console.log(error)
            //     data.result.write_date = dayjs()
            // }

            try {
                if (data?.result?.write_date) {
                    let datat = convertToISODate(data.result.write_date)
                    let datastm = new Date(data.result.write_date)
                    if (datat !== "Invalid Date") {
                        data.result.write_date = dayjs(datat).add(-543, 'year');
                    } else if (!(isNaN(datastm.getTime()))) {
                        data.result.write_date = dayjs(datastm)
                    } else {
            
                        data.result.write_date = dayjs()
                    }
                } else {
                    data.result.write_date = dayjs()
                }
            } catch (error) {
                console.log(error)
                data.result.write_date = dayjs()
            }

            try {
                if (data?.result?.business_create_date) {
                    let datat = convertToISODate(data.result.business_create_date)
                    let datastm = new Date(data.result.business_create_date)
                    if (datat !== "Invalid Date") {
                        data.result.business_create_date = dayjs(datat).add(-543, 'year');
                    } else if (!(isNaN(datastm.getTime()))) {
                        data.result.business_create_date = dayjs(datastm)
                    } else {
            
                        data.result.business_create_date = dayjs()
                    }
                } else {
                    data.result.business_create_date = dayjs()
                }
            } catch (error) {
                console.log(error)
                data.result.business_create_date = dayjs()
            }


            if (!(data?.result?.organization_data?.health_office_type)) {
                    data.result.organization_data.health_office_type = "คลินิก"
            }

            if (!(data?.result?.service_type)) {
                    data.result.service_type = "คลินิกเวชกรรม"
             }
                


                // data.result.service_type
                // คลินิกเวชกรรม

                //   data.result.co_professional[0].province = "อำนาจเจริญ"
                //     data.result.co_professional[0].district = "บ้านไผ่"
                //     data.result.co_professional[0].sub_district = "หัวหนอง"
                //     data.result.co_professional[0].zip_code = "xxxxxxxxxxxx"
                //     data.result.co_professional.push({...data.result.co_professional[0]})  
                //   data.result.co_professional[1].province = "อำนาจเจริญ"
                //   data.result.co_professional[1].district = "พนา"
                //   data.result.co_professional[1].sub_district = "พนา"
                // //   data.result.co_professional[1].zip_code = "xxxxxxxxxxxx"
                //     // data.result.current_address.district = "บ้านไผ่" // บ้านไผ่ ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// ต้องลบ
                //     // data.result.current_address.sub_district = "ในเมือง" // บ้านไผ่ ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// ต้องลบ
       

            if (!(Array.isArray(data.result.co_professional))) {
                data.result.co_professional = []
            }
            //  console.log("data.result", data.result)

            const org = JSON.parse(sessionStorage.getItem("organization") || "{}");
                        const dataToSend: FormData = {
                            ...formData,
                            ...data.result,
                            license_code:  formData.license_code || org.license_id || "",
                        };
            setFormData(dataToSend as any);
            // setFormData(dataToSend)


        } catch (error) {
            console.error(error);

        } finally {
            getDataAllProvince()
        }
    };


    const getDataAllProvince = async () => {
        try {
            const { data } = await webapi.get(`${APIEndpointWeb.GetAllProvince}`);
            // console.log(APIEndpointWeb.GetAllProvince, data)
            // // setAllProvince()
            if (Array.isArray(data.result)) {
                setAllProvince(data.result);
                // if (dataProvince) {
                //   const xml = data.result.find((p :any) => p.province_thai_name === dataProvince.province);
                //   if (xml) {
                //   await  getDataAllDistrict(xml, dataProvince)
                //   } else {
                //     let formDatamock = dataProvince
                //     formDatamock.province = ""
                //     formDatamock.district = ""
                //     formDatamock.sub_district = ""
                //     formDatamock.zip_code = ""
                //     setFormData(formDatamock)
                //   }
                // }
            } else {
                // console.error("Unexpected API response:", data);
                setAllProvince([]);
            }
        } catch (error) {
              console.log(error);
            //   setAllProvince([]);
        } finally {
            setLoading(false)
        }
    };


    const handleNewForm = () => {
        setLoading(true)
        var ctc: any = cloneDeep(formData);
        if (ctc.business_create_date) {
            ctc.business_create_date = dayjs(ctc.business_create_date).add(543, 'year').format('DD/MM/YYYY')
            //    console.log(dayjs(ctc.business_create_date).add(543, 'year').format('DD/MM/YYYY'))
        }
        if (ctc.write_date) {
            ctc.write_date = dayjs(ctc.write_date).add(543, 'year').format('DD/MM/YYYY')
            // console.log(dayjs(ctc.write_date).add(543, 'year').format('DD/MM/YYYY'))    
        }
        if (Array.isArray(ctc.co_professional) && ctc.co_professional.length <= 0) {
            ctc.co_professional = null
        }

        if (!(["สหคลินิก", "อื่นๆ"].includes(ctc.service_type))) {
            ctc.service_type_note = ""
        }
        // console.log("formData", ctc)

        if (checkPage234 === "3" && activeStep === 2) {
            editPriority3(ctc)
            return false
        }

        history.push("/form-personal", { state: { formData } });
        setLoading(false)
    };




    const editPriority3 = (data : FormData) => {
        try {
            var formDatamock:any = data
            formDatamock.document_no = resultDetail.document_no
            formDatamock.hcode = resultDetail.hcode
            formDatamock.ppho_code =  resultDetail.ppho_code
            formDatamock.access_token = accessToken
            setFormDatamockPriority3(formDatamock)
            setOpenConfirmDialog(true)
            // console.log("formDatamock", formDatamock)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }

 
    };

    const convertToISODate = (dateString: string) => {
        try {
            return dayjs(dateString, 'DD/MM/YYYY').format('YYYY-MM-DD');
        } catch (error) {
            return ""
        }

    };


    return (
        <Box
            sx={{
                borderRadius: "20px",
                padding: "30px 5px 5px 5px",
                backgroundColor: "#f5f5f5",
            }}
        >
           <LoadingIndicator open={loading} />
            <Box sx={{ height: "100%" }}>
                <Grid item xs={12}>
                    <Box
                        sx={{
                            borderRadius: "15px",
                            width: "100%",
                            backgroundColor: "#ffffff",
                            p: 4,
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                            <Link href="/document-personal" underline="none">
                                <NavigateBeforeIcon
                                    sx={{
                                        fontSize: 30,
                                        ml: 1,
                                        cursor: "pointer",
                                        mr: 1,
                                        color: "#474747",
                                    }}
                                />
                            </Link>
                            <Box>
                                <Typography variant="h5"sx={{ color: "#474747", fontSize: { xs: "16px", md:"24px",lg:"26px" } }}>
                                    เอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล DSA 
                                </Typography>
                            </Box>
                        </Box>

                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    p: 6,
                                    border: "2px solid #e5eef1",
                                    backgroundColor: "#f5fdff",
                                    borderRadius: "10px",
                                    mt: 2,
                                }}
                            >
                                <Typography sx={{ fontSize: { xs: "14px", md:"20px",lg:"20px" }, fontWeight: "bold" }}>
                                    ใบสมัครเข้าร่วมตามนโยบาย “๓๐ บาทรักษาทุกที่
                                    ด้วยบัตรประชาชนใบเดียว” ของหน่วยบริการเอกชน
                                </Typography>
                                <Typography sx={{ fontSize: { xs: "12px", md:"14px",lg:"16px" }, color: "#9C9C9C" }}>
                                    กรุณากรอกรายละเอียดของคุณด้านล่างเพื่อสมัครเข้าร่วมนโยบายและเริ่มต้นสร้างเอกสารสัญญา
                                    เพื่อลงนามใบรับรองอิเล็กทรอนิกส์
                                </Typography>

                                {/* Step Content */}
                                <Box sx={{ mt: 3 }}>
                                    {activeStep === 0 && (
                                        // <div>1</div>
                                        <FormPersonalInfoV1
                                            allProvince={allProvince}
                                            formData={formData}
                                            setFormData={setFormData}
                                            errors={errors}
                                            setErrors={setErrors}
                                        />
                                    )}
                                    {activeStep === 1 &&
                                        <ServiceinFoV1
                                            allProvince={allProvince}
                                            formData={formData}
                                            setFormData={setFormData}
                                            errors={errors}
                                            setErrors={setErrors} />
                                        // <div>2</div>
                                    }
                                    {activeStep === 2 &&
                                        <PersonSignV1
                                            allProvince={allProvince}
                                            formData={formData}
                                            setFormData={setFormData}
                                            errors={errors}
                                            setErrors={setErrors} />
                                        // <div>3</div>
                                    }
                                    {activeStep === 3 &&
                                        <AttachEvidenceV1
                                            formData={formData}
                                            setFormData={setFormData}
                                            errors={errors}
                                            setErrors={setErrors}
                                            setConsentAgreement={setConsentAgreement}
                                            consentAgreement={consentAgreement} />
                                        // <div>4</div>
                                    }
                                    <Grid container sx={{ mt: 5 }} spacing={2}>
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>
                                    {/* Navigation Buttons */}
                                    <Grid
                                        container
                                        sx={{
                                            mt: 3,
                                            flexDirection: { xs: "column", md: "row" },
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        {" "}
                                        <Grid item xs={12} md="auto" sx={{ mb: 2 }}>
                                            <Button
                                                variant="text"
                                                color="primary"
                                                sx={{ fontSize: "14px" }}
                                                onClick={handleBack}
                                                disabled={activeStep === 0}
                                            >
                                                <KeyboardArrowLeftIcon sx={{ mr: 0.5 }} />
                                                ย้อนกลับ
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md="auto" sx={{ mb: 2 }}>
                                            <Typography variant="body1">
                                                {activeStep + 1} / {checkPage234 === "3" ? (steps.length - 1) : (steps.length)}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md="auto">
                                            {/* {String(consentAgreement)} */}
                                            {activeStep === steps.length - 1 ? (
                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                        fontSize: "14px",
                                                        backgroundColor: "#2196F3",
                                                        borderRadius: "12px",
                                                        color: "white",
                                                        "&:hover": { backgroundColor: "#1976D2" },
                                                        px: 3,
                                                    }}
                                                    onClick={handleNewForm}
                                                    disabled={!consentAgreement}
                                                >
                                                    ดำเนินการต่อ
                                                </Button>
                                            ) : (
                                                <Button
                                                    variant="text"
                                                    color="primary"
                                                    onClick={handleNext}
                                                    sx={{ fontSize: "14px" }}
                                                >
                                               {checkPage234 === "3" && activeStep === 2 ?  "บันทึกการแก้ไขเอกสาร" : "ถัดไป"}<KeyboardArrowRightIcon sx={{ ml: 0.5 }} />
                                                </Button>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                        </Grid>
                    </Box>
                </Grid>
            </Box>
            <ConfirmAndSuccessDialog 
            openConfirmDialog= {openConfirmDialog}
            setOpenConfirmDialog={setOpenConfirmDialog}
            openSuccessDialog={openSuccessDialog}
            setOpenSuccessDialog={setOpenSuccessDialog}
            formDatamockPriority3={formDatamockPriority3}
            setLoading={setLoading}
            accessToken={accessToken}
            />
        </Box>
    );
}

export default MainFormPersonaNewV1;
